export default __webpack_public_path__ + "static/media/logo.daf86ed1.png";